import { useSeriesListQuery } from '../queries';
import { ForwardedRef, forwardRef, useMemo, useState } from 'react';
import { Input, SearchSelectProps } from '~/components/Input';
import { BaseFormState } from '~/types/BaseFormState';

type Props<TFormState extends BaseFormState> = Omit<
  SearchSelectProps<TFormState>,
  'options' | 'search' | 'setSearch' | 'isLoading'
>;

function SeriesSearchSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLInputElement>
) {
  const [search, setSearch] = useState<string>('');

  const { data, isLoading } = useSeriesListQuery(
    {
      page_size: 100,
      search,
    },
    search.length > 3
  );

  const options = useMemo<[string, number][]>(() => {
    return data?.results.map(({ id, name }) => [name, id]) ?? [];
  }, [data]);

  return (
    <Input.SearchSelect
      setSearch={setSearch}
      isLoading={isLoading}
      options={options}
      search={search}
      ref={ref}
      {...props}
    />
  );
}

export const SeriesSearchSelect = forwardRef(SeriesSearchSelectElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLInputElement> }
) => ReturnType<typeof SeriesSearchSelectElement>;
